import { Box, Flex } from '@chakra-ui/react';
import Card from './Card';

interface ThumbnailProps {
	data: any;
}
const Thumbnails = ({ data }: ThumbnailProps) => {
	return (
		<Box>
			<Flex flexWrap={'wrap'} alignItems={'flex-start'}>
				{data.length > 0 &&
					data.map((item: any) => (
						<>
							<Card data={item} />
						</>
					))}
			</Flex>
		</Box>
	);
};

export default Thumbnails;
